"use client"
import { Button, SxProps } from "@mui/material"
import { getNonUmbracoUrl } from "utils"

type PortPrimaryButtonProps = {
  button: any
  sx?: SxProps
  textContent?: string
}

const PortPrimaryButton = ({ button, sx, textContent }: PortPrimaryButtonProps) => {
  return (
    button?.url &&
    button?.name && (
      <Button
        variant="contained"
        sx={{
          fontSize: {
            xs: "18px",
          },
          fontWeight: {
            xs: "700",
          },
          minWidth: {
            xs: "103px",
            md: "200px",
          },
          justifySelf: "center",
          height: {
            xs: "48px",
          },
          ...sx,
        }}
        target={button.target ? button.target : "_self"}
        href={getNonUmbracoUrl(button.url)}
        onClick={(e) => {
          const href = getNonUmbracoUrl(button.url)
          if (href.includes("#")) {
            e.preventDefault()
            const anchor = href.split("#")[1]
            const element = document.getElementById(anchor)
            if (element) {
              element.scrollIntoView({ behavior: "smooth" })
            }
          }
        }}
      >
        {textContent || button.name}
      </Button>
    )
  )
}
export default PortPrimaryButton
